// actions/door/search.js

import { attachAuth } from '../../utils/authService';

export function doorsHasErrored(bool) {
  return {
    type: 'DOORS_HAS_ERRORED',
    hasErrored: bool
  };
}

export function doorsIsLoading(bool) {
  return {
    type: 'DOORS_IS_LOADING',
    isLoading: bool
  };
}

export function doorsFetchDataSuccess(list) {
  return {
    type: 'DOORS_FETCH_DATA_SUCCESS',
    list
  };
}

export function doorsFetchData(host) {
  return (dispatch) => {
    dispatch(doorsIsLoading(true));
    dispatch(doorsHasErrored(false));
    fetch(host + 'door/doors', {
      method: 'get',
      headers: attachAuth()
    }).then(promise => {
      if (!promise.ok) {
        throw Error(promise.statusText);
      }
        
      dispatch(doorsIsLoading(false));
      promise.json()
        .then(result => {        
          var doors = [];
          result.forEach(function(element) {
            doors = doors.concat(element.doors);
          });
          
          dispatch(doorsFetchDataSuccess(doors))
        })
        .catch((e) => {
          console.log(e);
          dispatch(doorsHasErrored(true))
        });
      })
      .catch((e) => {
        console.log(e);
        dispatch(doorsHasErrored(true))
      });
  };
}